/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import {ModelBase} from "./model-base";
import {IModelBase} from "./i-model-base";
import {TagNl} from "./tag-nl";
import {CompositionComponentLinkerDto} from "../_models/_inventory/composition-component-linker-dto";

export class CompositionDto extends ModelBase implements IModelBase {
  // components: ComponentNl[] = [];
  componentLinkers: CompositionComponentLinkerDto[] = [];

  price: number = 0;
  tags: TagNl[] = [];
  special: boolean = false;
  compositionType: string | undefined;
  order: number = 0;

  // calculated price from business cases and overrides
  oPrice: number | undefined;
}
